import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=93d1798a"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports